import React from "react";
import DeleteIcon from "../../../../assets/icons/bin.svg";

// Styles
import "./SavedView.scss";

const SavedView = ({ title, id, handleClick, handleDelete, selected, columns, setShowDeleteModal }) => {
  const handleDeleteClick = () => {
    setShowDeleteModal({ id, title, status: true });
  };
  const handleSelectClick = () => {
    handleClick({ id, columns, title });
  };
  return (
    <div className={`saved-view ${selected ? `saved-view-selected` : ``}`}>
      <span className="title" onClick={handleSelectClick}>
        {title}
      </span>
      <span className="delete">
        <img src={DeleteIcon} alt="Saved views dropdown" width="18" height="18" onClick={handleDeleteClick} />
      </span>
    </div>
  );
};

export default SavedView;
